import React from 'react'
import {
  FVLogo,
  FVDecipherLogo,
  FVInterVuNowLogo,
  FVKinesisLogo,
  FVRevelationLogo,
  FVVideoInsightsLogo
} from 'stylist'

const AppLogo = ({ clientId, ...rest }) => {
  switch (clientId) {
    case 'decipher':
      return <FVDecipherLogo {...rest} />
    case 'kinesis':
      return <FVKinesisLogo {...rest} />
    case 'intervunow':
      return <FVInterVuNowLogo {...rest} />
    case 'revelation':
      return <FVRevelationLogo {...rest} />
    case 'vi':
      return <FVVideoInsightsLogo {...rest} />
    default:
      return <FVLogo {...rest} />
  }
}

export default AppLogo



// WEBPACK FOOTER //
// ./src/components/AppLogo.js